module.exports = __webpack_public_path__ + "img/管理.c390fcc2.png";